import { type ServiceTree } from './types';

export const defineClient = <T extends Record<string, ServiceTree<unknown>>>(config: T): T =>
    config;
